import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

import Home from './pages/Home';
import PageBr from './pages/PageBr';
import PageEn from './pages/PageEn';
import Imprensa from './pages/Imprensa';
import Inscricao from './pages/Inscricao';
import InscricaoImprensa from './pages/InscricaoImprensa';
import City from './pages/City';
import Login from './pages/Login';
import Salas from './pages/Salas';
import Agenda from './pages/Agenda';
import Events from './pages/Events';
import Hotel from './pages/Hotel';
import News from './pages/News';
import Panel from './pages/Panel';
import Abstract from './pages/Abstract';

export default function Routing() {
    
    return (
        <BrowserRouter>
            <Routes>
                <Route path="/" exact element={<Home />} />
                <Route path="/home" element={<Home />} />
                <Route path="/br" element={<PageBr />} />
                <Route path="/en" element={<PageEn />} />
                <Route path="/inscricao" element={<Inscricao />} />
                <Route path="/inscricao-vip" element={<Inscricao />} />
                <Route path="/inscricao-imprensa" element={<InscricaoImprensa />} />
                <Route path="/cidade-sao-paulo" element={<City />} />
                <Route path="/imprensa" element={<Imprensa />} />
                <Route path="/login" element={<Login />} />
                <Route path="/assistir" element={<Salas />} />
                <Route path="/sala/:url?" element={<Salas />} />
                <Route path="/noticias" element={<News />} />
                <Route path="/noticia/:url?" element={<News />} />
                <Route path="/palestrantes" element={<Panel />} />
                <Route path="/palestrante/:url?" element={<Panel />} />
                <Route path="/resumos" element={<Abstract />} />
                <Route path="/resumo/:url?" element={<Abstract />} />
                <Route path="/eventos" element={<Events />} />
                <Route path="/evento/:url?" element={<Events />} />
                <Route path="/programacao" element={<Agenda />} />
                <Route path="/hoteis" element={<Hotel />} />
            </Routes>
        </BrowserRouter>
    );
}